import ability from './ability'

export const canNavigate = to => {
  // Ignora verificação se a rota for pública
  if (to.meta.public) return true
  return to.matched.some(route => ability.can(route.meta.action || 'read', route.meta.resource))
}

export const _ = undefined
